// // ============================================================
// // src/components/admin/AdminModal.js
// // ============================================================
// import React, { useEffect } from "react";
// import { useAuth } from "../../context/AuthContext";
// import AdminLogin from "./AdminLogin";
// import AdminDashboard from "./AdminDashboard";

// export default function AdminModal({ onClose, showToast }) {
//   const { isLoggedIn } = useAuth();

//   useEffect(() => {
//     const handler = (e) => {
//       if (e.key === "Escape" && !isLoggedIn) onClose();
//     };
//     document.addEventListener("keydown", handler);
//     document.body.style.overflow = "hidden";
//     return () => {
//       document.removeEventListener("keydown", handler);
//       document.body.style.overflow = "";
//     };
//   }, [onClose, isLoggedIn]);

//   return (
//     <div
//       className="admin-modal-overlay open"
//       onClick={(e) => {
//         if (e.target === e.currentTarget && !isLoggedIn) onClose();
//       }}
//     >
//       <div className="admin-modal-box">
//         <div className="admin-modal-header">
//           <span>Doctor Admin Panel</span>
//           <button className="admin-close-btn" onClick={onClose}>
//             ✕
//           </button>
//         </div>
//         <div className="admin-modal-body">
//           {!isLoggedIn ? (
//             <AdminLogin showToast={showToast} />
//           ) : (
//             <AdminDashboard showToast={showToast} />
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

/////////////// subscription gate
// // ============================================================
// // src/components/admin/AdminModal.js
// // ✅ Subscription gate — fetches fresh status directly from API
// // ============================================================
// import React, { useEffect, useState } from "react";
// import { useAuth } from "../../context/AuthContext";
// import { useHospital } from "../../context/HospitalContext";
// import AdminLogin from "./AdminLogin";
// import AdminDashboard from "./AdminDashboard";

// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

// export default function AdminModal({ onClose, showToast }) {
//   const { isLoggedIn } = useAuth();
//   const { hospital } = useHospital();
//   const [subStatus, setSubStatus] = useState(null); // null = checking

//   // ✅ Fetch FRESH subscription status directly from API on every open
//   useEffect(() => {
//     const checkSub = async () => {
//       // PearlSmile is never blocked
//       if (!hospital?._id || hospital?.slug === "pearlsmile") {
//         setSubStatus("active");
//         return;
//       }
//       try {
//         const res = await fetch(
//           `${API_URL}/superadmin/payment/status/${hospital._id}`,
//         );
//         const data = await res.json();
//         // ✅ Block if status is expired/blocked OR if days left <= 0
//         if (
//           data.subscriptionStatus === "expired" ||
//           data.subscriptionStatus === "blocked" ||
//           data.isExpired === true ||
//           data.daysLeft <= 0
//         ) {
//           setSubStatus("expired");
//         } else {
//           setSubStatus(data.subscriptionStatus);
//         }
//       } catch (_) {
//         setSubStatus("active"); // if API fails, allow access
//       }
//     };
//     checkSub();
//   }, [hospital?._id, hospital?.slug]);

//   useEffect(() => {
//     const handler = (e) => {
//       if (e.key === "Escape" && !isLoggedIn) onClose();
//     };
//     document.addEventListener("keydown", handler);
//     document.body.style.overflow = "hidden";
//     return () => {
//       document.removeEventListener("keydown", handler);
//       document.body.style.overflow = "";
//     };
//   }, [onClose, isLoggedIn]);

//   const isExpiredOrBlocked = subStatus === "expired" || subStatus === "blocked";

//   return (
//     <div
//       className="admin-modal-overlay open"
//       onClick={(e) => {
//         if (e.target === e.currentTarget && !isLoggedIn) onClose();
//       }}
//     >
//       <div className="admin-modal-box">
//         <div className="admin-modal-header">
//           <span>Doctor Admin Panel</span>
//           <button className="admin-close-btn" onClick={onClose}>
//             ✕
//           </button>
//         </div>
//         <div className="admin-modal-body">
//           {/* Still checking */}
//           {subStatus === null && (
//             <div
//               style={{
//                 textAlign: "center",
//                 padding: "48px 24px",
//                 color: "#94a3b8",
//                 fontSize: 13,
//               }}
//             >
//               Checking subscription...
//             </div>
//           )}

//           {/* Blocked */}
//           {isExpiredOrBlocked && (
//             <div style={{ textAlign: "center", padding: "48px 24px" }}>
//               <div style={{ fontSize: 52, marginBottom: 16 }}>🔒</div>
//               <h3
//                 style={{
//                   fontSize: 18,
//                   fontWeight: 800,
//                   color: "#0a1628",
//                   marginBottom: 8,
//                 }}
//               >
//                 Subscription Expired
//               </h3>
//               <p
//                 style={{
//                   fontSize: 13,
//                   color: "#64748b",
//                   marginBottom: 24,
//                   lineHeight: 1.6,
//                 }}
//               >
//                 Your VidyaOne subscription has expired.
//                 <br />
//                 Contact VidyaOne to renew and restore access.
//               </p>
//               <a
//                 href="https://wa.me/918793608083?text=Hi VidyaOne, I want to renew my hospital subscription."
//                 target="_blank"
//                 rel="noreferrer"
//                 style={{
//                   display: "inline-block",
//                   padding: "11px 24px",
//                   background: "#25d366",
//                   color: "#fff",
//                   borderRadius: 10,
//                   fontWeight: 700,
//                   fontSize: 13,
//                   textDecoration: "none",
//                   marginBottom: 12,
//                 }}
//               >
//                 💬 Contact VidyaOne on WhatsApp
//               </a>
//               <br />
//               <button
//                 onClick={onClose}
//                 style={{
//                   marginTop: 8,
//                   padding: "9px 20px",
//                   background: "transparent",
//                   color: "#94a3b8",
//                   border: "1px solid #e2e8f0",
//                   borderRadius: 8,
//                   fontSize: 12,
//                   fontWeight: 600,
//                   cursor: "pointer",
//                   fontFamily: "DM Sans,sans-serif",
//                 }}
//               >
//                 Close
//               </button>
//             </div>
//           )}

//           {/* Normal flow */}
//           {subStatus !== null &&
//             !isExpiredOrBlocked &&
//             (!isLoggedIn ? (
//               <AdminLogin showToast={showToast} />
//             ) : (
//               <AdminDashboard showToast={showToast} />
//             ))}
//         </div>
//       </div>
//     </div>
//   );
// }

// ============================================================
// src/components/admin/AdminModal.js
// ✅ Subscription gate — fetches fresh status directly from API
// ✅ Rebranded: VidyaOne → PranJeev
// ============================================================
import React, { useEffect, useState } from "react";
import { useAuth } from "../../context/AuthContext";
import { useHospital } from "../../context/HospitalContext";
import AdminLogin from "./AdminLogin";
import AdminDashboard from "./AdminDashboard";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";

export default function AdminModal({ onClose, showToast }) {
  const { isLoggedIn } = useAuth();
  const { hospital } = useHospital();
  const [subStatus, setSubStatus] = useState(null);

  useEffect(() => {
    const checkSub = async () => {
      if (!hospital?._id || hospital?.slug === "pearlsmile") {
        setSubStatus("active");
        return;
      }
      try {
        const res = await fetch(
          `${API_URL}/superadmin/payment/status/${hospital._id}`,
        );
        const data = await res.json();
        if (
          data.subscriptionStatus === "expired" ||
          data.subscriptionStatus === "blocked" ||
          data.isExpired === true ||
          data.daysLeft <= 0
        ) {
          setSubStatus("expired");
        } else {
          setSubStatus(data.subscriptionStatus);
        }
      } catch (_) {
        setSubStatus("active");
      }
    };
    checkSub();
  }, [hospital?._id, hospital?.slug]);

  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape" && !isLoggedIn) onClose();
    };
    document.addEventListener("keydown", handler);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", handler);
      document.body.style.overflow = "";
    };
  }, [onClose, isLoggedIn]);

  const isExpiredOrBlocked = subStatus === "expired" || subStatus === "blocked";

  return (
    <div
      className="admin-modal-overlay open"
      onClick={(e) => {
        if (e.target === e.currentTarget && !isLoggedIn) onClose();
      }}
    >
      <div className="admin-modal-box">
        <div className="admin-modal-header">
          <span>Doctor Admin Panel</span>
          <button className="admin-close-btn" onClick={onClose}>
            ✕
          </button>
        </div>
        <div className="admin-modal-body">
          {subStatus === null && (
            <div
              style={{
                textAlign: "center",
                padding: "48px 24px",
                color: "#94a3b8",
                fontSize: 13,
              }}
            >
              Checking subscription...
            </div>
          )}

          {isExpiredOrBlocked && (
            <div style={{ textAlign: "center", padding: "48px 24px" }}>
              <div style={{ fontSize: 52, marginBottom: 16 }}>🔒</div>
              <h3
                style={{
                  fontSize: 18,
                  fontWeight: 800,
                  color: "#0a1628",
                  marginBottom: 8,
                }}
              >
                Subscription Expired
              </h3>
              <p
                style={{
                  fontSize: 13,
                  color: "#64748b",
                  marginBottom: 24,
                  lineHeight: 1.6,
                }}
              >
                Your PranJeev subscription has expired.
                <br />
                Contact PranJeev to renew and restore access.
              </p>
              <a
                href="https://wa.me/918793608083?text=Hi PranJeev, I want to renew my hospital subscription."
                target="_blank"
                rel="noreferrer"
                style={{
                  display: "inline-block",
                  padding: "11px 24px",
                  background: "#25d366",
                  color: "#fff",
                  borderRadius: 10,
                  fontWeight: 700,
                  fontSize: 13,
                  textDecoration: "none",
                  marginBottom: 12,
                }}
              >
                💬 Contact PranJeev on WhatsApp
              </a>
              <br />
              <button
                onClick={onClose}
                style={{
                  marginTop: 8,
                  padding: "9px 20px",
                  background: "transparent",
                  color: "#94a3b8",
                  border: "1px solid #e2e8f0",
                  borderRadius: 8,
                  fontSize: 12,
                  fontWeight: 600,
                  cursor: "pointer",
                  fontFamily: "DM Sans,sans-serif",
                }}
              >
                Close
              </button>
            </div>
          )}

          {subStatus !== null &&
            !isExpiredOrBlocked &&
            (!isLoggedIn ? (
              <AdminLogin showToast={showToast} />
            ) : (
              <AdminDashboard showToast={showToast} />
            ))}
        </div>
      </div>
    </div>
  );
}
